import { Link } from "react-router";

import { RedPen } from "../ui/RedPen";
import { useTitle } from "../ui/hooks";

export function NotFound() {
  useTitle("Not found");
  return (
    <section className="wrap py-28">
      <p className="kicker">404</p>
      <h1 className="display mt-4 max-w-3xl text-6xl sm:text-7xl">
        This page was <RedPen kind="strike">marked</RedPen> missing.
      </h1>
      <p className="lede mt-6 max-w-xl">It may have moved, or never existed. The workflows, the articles and the Charter are all still here.</p>
      <div className="mt-8 flex flex-wrap gap-3">
        <Link to="/" className="btn-ink">
          Go home
        </Link>
        <Link to="/workflows" className="btn-line">
          Browse workflows
        </Link>
      </div>
    </section>
  );
}
